import { Component, OnInit } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public form: UntypedFormGroup;
  public settings: Settings;

  constructor(public appSettings: AppSettings, public router: Router, public fb: UntypedFormBuilder) {
    this.settings = appSettings.settings;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  public onSubmit(values: Object): void {
    if (this.form.valid) {
      this.router.navigate(['/search', values['param']]);
    }
  }
}
